require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./ar-eg-region-امريكا-اللاتينية.json") })
        }
      }, "path---ar-eg-region-امريكا-اللاتينية");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---ar-eg-region-امريكا-اللاتينية!./.cache/json/ar-eg-region-امريكا-اللاتينية.json
// module id = 444
// module chunks = 231608221292675